// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-page[data-v-4bf94b44] {\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  margin-top: 200px;\n}\n.error-page i[data-v-4bf94b44] {\n  color: #003e8e;\n  font-size: 60px;\n}\n.error-page .error-page-desc[data-v-4bf94b44] {\n  margin-top: 60px;\n  color: rgba(0, 0, 0, 0.85);\n  font-size: 24px;\n  line-height: 1.8;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
